<template>
  <div>
    <div class="sayfahead tek">
      <h1>Bina Listesi</h1>
      <el-button-group class="float-right YeniBtn">
        <el-button type="primary" size="small" @click="YeniBtn">Bina Ekle</el-button>
      </el-button-group>
    </div>
    <div class="icerik" style="height: calc(100vh - 20px)">
      <div class="SpotlightKutu" style="z-index: 1">
        <el-row :gutter="24">
          <el-col :span="20">
            <div class="input">
              <el-input
                :disabled="lo"
                placeholder="Bina Adı, Açıklama, Cihaz adı, Cari Kodu, Sorumlu ,Referans, Bölge, Bina Yönetimi yazarak aratınız"
                v-model="Kelime"
                @keyup.enter.native="SayfaYukle">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
          </el-col>
          <el-col :span="2" v-if="Hesap_id==6">
            <el-popover
              placement="bottom"
              width="250"
              trigger="click">
              <div class="BinaFiltre">
                <h5>
                  <el-checkbox v-model="Filtre">Filtreleme Aktif</el-checkbox>
                </h5>
                <p>
                  <el-checkbox v-model="Duzenleme">Duzenleme Aktif</el-checkbox>
                </p>
                <div v-if="Filtre">
                  <p>
                    <el-checkbox v-model="Filtreleme.Referans">Referans Olmayan</el-checkbox>
                  </p>
                  <p>
                    <el-checkbox v-model="Filtreleme.Sorumlu">Sorumlu Olmayan</el-checkbox>
                  </p>
                  <p>
                    <el-checkbox v-model="Filtreleme.Email">Email Olmayan</el-checkbox>
                  </p>
                  <p>
                    <el-checkbox v-model="Filtreleme.oBolge">Bölge Olmayan</el-checkbox>
                  </p>
                  <p>
                    <el-checkbox v-model="Filtreleme.EntegreKodu">Cari Olmayan</el-checkbox>
                  </p>
                  <p>
                    <el-checkbox v-model="Filtreleme.Koordinat">Koordinat Olmayan</el-checkbox>
                  </p>
                  <p>
                    <el-checkbox v-model="Filtreleme.oGun">Okuma Gün Olmayan</el-checkbox>
                  </p>
                </div>
              </div>
              <el-button slot="reference" size="small" class="btn-block">Filtre</el-button>
            </el-popover>
          </el-col>
          <el-col :span="Hesap_id==6?2:4">
            <el-button @click="SayfaYukle" type="success" size="small" class="btn-block">Getir</el-button>
          </el-col>
        </el-row>
      </div>
      <hr>
      <DuzenlemeTable v-if="Hesap_id==6 && Duzenleme" :data="dData"></DuzenlemeTable>
      <el-table
        v-if="BinaListe && !Duzenleme"
        :data="BinaListe.filter(data => !search || data.Adi.toLowerCase().includes(search.toLowerCase()))"
        :height="Height"
        @current-change="TableSecim"
        class="golgetable">
        <el-table-column
          label="Bina Adı"
          prop="Adi">
        </el-table-column>
        <el-table-column
          label="İlgili"
          prop="Ilgili"
          width="200">
        </el-table-column>
        <el-table-column
          label="İletişim"
          prop="Iletisim"
          width="200">
        </el-table-column>
        <el-table-column
          label="Durum"
          prop="DurumText"
          width="100">
        </el-table-column>
        <el-table-column
          label="Uzaktan Okuma"
          prop="ufirma"
          width="200">
        </el-table-column>
        <el-table-column
          label="Cari Kodu"
          prop="EntegreKodu"
          width="100">
        </el-table-column>
      </el-table>
      <Yukleniyor :data="lo"></Yukleniyor>
      <EsayacBinaModal :Modal="Modal" :Baslik="ModalBaslik" :BinaBilgi="BinaBilgi" v-if="Modal"
                       @ModalOlayi="Modal=false"></EsayacBinaModal>
      <BinaEntegreModal v-if="BinaCekModal" :Modal="BinaCekModal" @ModalOlayi="BinaCekModal=false"></BinaEntegreModal>
    </div>
  </div>
</template>
<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";
import EsayacBinaModal from "../../../components/Pack/Esayac/EsayacBinaModal";
import DuzenlemeTable from "./DuzenlemeTable";
import BinaEntegreModal from "../../../components/Pack/Esayac/BinaEntegreModal";

export default {
  components: {BinaEntegreModal, DuzenlemeTable, EsayacBinaModal, Yukleniyor},
  data() {
    return {
      search: null,
      Hesap_id: null,
      Filtre: false,
      BinaCekModal: false,
      Duzenleme: false,
      Filtreleme: {
        AVT: false,
        Referans: false,
        Sorumlu: false,
        oBolge: false,
        Koordinat: false,
        oGun: false,
        Email: false,
        EntegreKodu: false
      },
      Height: window.innerHeight - 130,
      lo: false,
      BinaListe: null,
      dData: null,
      Kelime: null,
      Modal: false,
      BinaBilgi: null,
      ModalBaslik: 'Bina Ekle'
    }
  },
  methods: {
    TableSecim(val) {
      this.$router.push('/bina/' + val.id)
    },
    YeniBtn() {
      this.BinaBilgi = null;
      this.ModalBaslik = 'Bina Ekle';
      this.Modal = true;
    },
    SayfaYukle() {
      this.lo = true
      this.$store.dispatch("Post", {
        Kelime: this.Kelime,
        Filtre: this.Filtre,
        Filtreleme: this.Filtreleme, path: '_enerji/binaarama'
      })
        .then(response => {
          this.lo = false
          if (response.Durum === 'OK') {
            this.BinaListe = response.Liste;
            this.dData = response.dData;

          } else {
            this.$message.error(response.Mesaj);
          }
        });
    }
  },
  created() {
    //this.SayfaYukle()

    this.Hesap_id = JSON.parse(localStorage.getItem('_aiHesap'))['id'];
  }
}
</script>

<style scoped>
.BinaFiltre {
  padding: 10px;
  text-align: left;
}

.BinaFiltre h5 {
  text-align: center;
  border-bottom: 1px solid #ccc;
  font-size: 18px;
  margin-bottom: 10px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/_Sayac/Bina/Index.vue